/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Swal from 'sweetalert2'
import {extend, localize, ValidationProvider, ValidationObserver} from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en.json'
import nl from 'vee-validate/dist/locale/nl.json'
import VueSignature from "vue-signature-pad";
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vue from 'vue'

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule])
})

//install languages
localize({en,nl});

//activate language set by app.blade.php
localize(window._locale);

window.Swal = Swal
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000
})

window.storageKey = "offlineForm";

window.Toast = Toast

window.Vue = require('vue').default;
Vue.use(VueSignature);

//Translations
Vue.mixin(require('./trans'))

window.moment = moment
Vue.prototype.$moment = moment

// require('./localStorageSync');
Vue.component('multiselect', Multiselect)
Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)

//Profile
Vue.component('profile-component', require('./Pages/profile/profileComponent').default)
Vue.component('profile-api-component', require('./Pages/profile/apiTokenComponent').default)

//Instructor
Vue.component('instructor-component', require('./Pages/instructors/instructorsComponent').default)
Vue.component('instructors-modal', require('./Pages/instructors/modals/instructorsModal').default)
Vue.component('offline-detection-component', require('./Components/OfflineDetectionComponent').default)

//Admin
Vue.component('admin-component', require('./Pages/admins/adminsComponent').default)
Vue.component('admin-modal', require('./Pages/admins/modals/adminModal').default)
Vue.component('admin-notifications-component', require('./Pages/admins/notificationsComponent').default)
Vue.component('system-admin-component', require('./Pages/system/SystemAdminComponent').default)

// Schedules
Vue.component('schedules-component', require('./Pages/schedules/ScheduleComponent').default)
//Vue.component('add-schedule-modal', require('./Pages/schedules/modals/AddScheduleModal').default)
Vue.component('view-schedule-modal', require('./Pages/schedules/modals/ViewScheduleModal').default)
Vue.component('upcoming-schedules-component', require('./Pages/schedules/UpcomingSchedulesComponent').default)
Vue.component('import-schedule-component', require('./Pages/schedules/ImportScheduleComponent').default)
Vue.component('addupdate-schedule-component', require('./Pages/schedules/AddUpdateScheduleComponent').default)

Vue.component('pagination-component', require('./Components/pagination/paginationComponent').default)

// questionnaires
Vue.component('questionnaires-component', require('./Pages/questionnaires/ListQuestionnairesComponent').default)
Vue.component('available-questionnaires-component', require('./Pages/questionnaires/ListAvailableQuestionnairesComponent').default)
Vue.component('offline-questionnaires-component', require('./Pages/questionnaires/OfflineQuestionnairesComponent').default)
Vue.component('debug-questionnaires-component', require('./Pages/questionnaires/DebugQuestionnairesComponent').default)
Vue.component('edit-questionnaires-component', require('./Pages/questionnaires/EditQuestionnairesComponent').default)
Vue.component('fill-questionnaire-component', require('./Pages/questionnaires/FillQuestionnaireComponent').default)
Vue.component('new-questionnaire-modal', require('./Pages/questionnaires/modals/NewQuestionnaireModal').default)
Vue.component('add-edit-section-modal', require('./Pages/questionnaires/modals/AddEditSectionModal').default)

//Forms
Vue.component('manage-forms-component', require('./Pages/forms/ManageFormsComponent').default)
Vue.component('edit-form-component', require('./Pages/forms/EditFormComponent').default)

const app = new Vue({
    el: '#app',
});
